/*
 * 新規登録（api create）
 */
import { apiCreate } from '@/actions/ApiBaseActions';
export const API_CREATE_USER_REGISTRATION = 'API_CREATE_USER_REGISTRATION';
export const API_CREATE_USER_REGISTRATION_SUCCESS = 'API_CREATE_USER_REGISTRATION_SUCCESS';
/**
 * 新規登録
 * @param data
 * @param meta
 * @returns
 */
export const apiCreateUserRegistration = (data, meta) => apiCreate(API_CREATE_USER_REGISTRATION, '/registration', Object.assign(Object.assign({}, data.json), { registrationUrl: data.json.registrationUrl || window.location.href }), Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
